import React from 'react';

const IconCard1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M39.0014 19.3638C39.0014 19.9999 38.4498 20.4958 37.8172 20.4286L11.7137 17.6496C10.8792 17.5608 10.2467 16.8571 10.2467 16.0181V13.6828C10.2467 12.6642 11.1647 11.8917 12.1683 12.066L38.1139 16.5749C38.6268 16.6641 39.0014 17.1092 39.0014 17.63V19.3638ZM39.4875 13.1689L11.125 8.08317C7.93306 7.51058 5 9.96447 5 13.2076V33.9484C5 37.1375 7.84162 39.5769 10.9939 39.0945L39.4088 34.7449C40.9338 34.5115 42.06 33.1999 42.06 31.6571V16.2439C42.06 14.7313 40.9765 13.436 39.4875 13.1689Z" fill="#5A72FF" />
  </svg>
);

export default IconCard1;
